
const link = {
    label: 'Link',
    name: 'link',
    widget: 'object',
    fields: [
        {
            label: 'Name',
            name: 'name',
            widget: 'string',
            default: '',
        },
        {
            label: 'URL',
            name: 'url',
            widget: 'string',
            default: '',
        },
    ],
}

export default {
    label: 'Navigation',
    name: 'navigation',
    file: 'src/content/components/navigation.json',
    format: 'json',
    i18n: true,
    create: true,
    fields: [
        {
            label: 'Links',
            name: 'links',
            widget: 'list',
            i18n: true,
            types: [
                link,
                {
                    label: 'Dropdown',
                    name: 'dropdown',
                    widget: 'object',
                    fields: [
                        {
                            label: 'Name',
                            name: 'name',
                            widget: 'string',
                            default: '',
                            i18n: true,
                        },
                        {
                            label: 'Links',
                            name: 'links',
                            widget: 'list',
                            types: [
                                link,
                            ],
                        },
                    ],
                }
            ],
        },
        {
            label : 'Desktop Navigation Aria Label',
            name : 'aria-desktop-navigation',
            widget : 'string',
            default : 'Navigatsiooni menüü arvutitele',
            i18n : true,
        },
        {
            label : 'Mobile Navigation Aria Label',
            name : 'aria-mobile-navigation',
            widget : 'string',
            default : 'Navigatsiooni menüü mobiilidele',
            i18n : true,
        },
        {
            label : 'Mobile Navigation Toggle Aria Label',
            name : 'aria-mobile-navigation-toggle',
            widget : 'string',
            default : 'Navigatsiooni menüü avamise nupp',
            i18n : true,
        },
    ],
};